// extracted by mini-css-extract-plugin
export default {"overlay":"_B-z","bodyOpen":"aC-z","content":"bC-z","header":"cC-z","close":"dC-z","closeNoHeading":"eC-z"};